import { Link } from 'react-router-dom';
import { ChevronRight } from '@nexdel/core/utils/icons';
import { usePageHeaderState } from '@nexdel/core/hooks/use-page-header';

export function AppHeader() {
  const header = usePageHeaderState();

  if (!header) return <div className="h-11 border-b border-border shrink-0" />;

  return (
    <div className="h-11 border-b border-border px-5 flex items-center justify-between shrink-0 gap-4">
      <div className="flex items-center gap-1.5 min-w-0">
        {header.breadcrumbs && header.breadcrumbs.length > 0 ? (
          <>
            {header.breadcrumbs.map((crumb, i) => (
              <span key={i} className="flex items-center gap-1.5">
                {crumb.href ? (
                  <Link to={crumb.href} className="text-xs text-muted-foreground hover:text-foreground transition truncate">
                    {crumb.label}
                  </Link>
                ) : (
                  <span className="text-xs text-muted-foreground truncate">{crumb.label}</span>
                )}
                <ChevronRight size={12} className="text-muted-foreground/50 shrink-0" />
              </span>
            ))}
            <span className="text-xs font-medium text-foreground truncate">{header.title}</span>
          </>
        ) : (
          <span className="text-sm font-semibold text-foreground truncate">{header.title}</span>
        )}
        {header.subtitle && (
          <span className="text-xs text-muted-foreground truncate">{header.subtitle}</span>
        )}
      </div>
      {header.actions && (
        <div className="flex items-center gap-2 shrink-0">{header.actions}</div>
      )}
    </div>
  );
}
